const features = [
  {
    title: '海量内容 · 一站聚合',
    desc: '覆盖娱乐圈、网红圈、社会事件三大板块，收录200+条爆料线索与30+个垂直话题领域，无需切换多个平台即可掌握全网吃瓜动态。',
    icon: 'ri-stack-line',
  },
  {
    title: '实时更新 · 入口稳定',
    desc: '人工审核每日更新，持续监控各站点入口可用性，确保访问通道始终畅通。入口可用率保持在99.8%以上，让你随时吃瓜不迷路。',
    icon: 'ri-refresh-line',
  },
  {
    title: '多端覆盖 · 随时随地',
    desc: '提供网页版与移动APP双端访问，支持推送通知与离线阅读。无论你是在电脑前还是通勤路上，最新爆料都不会错过。',
    icon: 'ri-smartphone-line',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">平台特色</h2>
            <p className="text-sm text-foreground-500">为什么选择51暗网作为你的吃瓜入口</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {features.map((f, i) => (
              <div key={i} className="bg-background-100 rounded-lg border border-background-300/40 p-6 hover:border-background-300/70 transition-all duration-200 text-center group">
                <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-accent-500/10 flex items-center justify-center group-hover:bg-accent-500/20 transition-colors">
                  <i className={`${f.icon} text-2xl text-accent-400`}></i>
                </div>
                <h3 className="font-heading text-base text-foreground-900 mb-3">{f.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}